import { useEffect } from 'react';

export const useVh = () => {
  useEffect(() => {
    const setVh = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };

    setVh();

    window.addEventListener('resize', setVh);
    window.addEventListener('orientationchange', setVh);

    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        setVh();
      }
    });

    return () => {
      window.removeEventListener('resize', setVh);
      window.removeEventListener('orientationchange', setVh);
      document.removeEventListener('visibilitychange', setVh);
    };
  }, []);
};
